import React from 'react';
import { createRoot } from 'react-dom/client';
import "antd/dist/reset.css";
import "./common/style/reset.css";
import "./common/style/global.css";
import App from './App';
// import reportWebVitals from './reportWebVitals';
import './config/i18n';
import GlobalLoader, {
  GlobalLoadingView,
} from "./components/GlobalLoading";

const root = createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <GlobalLoadingView
      ref={(globalLoaderRef) => {
        GlobalLoader.setGlobalLoader(globalLoaderRef);
      }}
    />
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();